'use strict';

import angular from 'angular';

// http://stackoverflow.com/a/25885501
export function abs() {
  return function(val) {
    return Math.abs(val);
  };
}

// http://stackoverflow.com/a/25885501
export function sumFinancial() {
  return function(data, key, options) {
    if(angular.isUndefined(data)) {
      return 0;
    }
    key = key || 'amount';
    var sum = 0;
    angular.forEach(data, function(value) {
      // ensure floating point isn't an issue
      var incrementalValue = Math.round(value[key] * 100) / 100;
      // divide by 100 for cents
      incrementalValue = incrementalValue / 100;
      if(options === 'positive') {
        incrementalValue = incrementalValue > 0 ? incrementalValue : 0;
      } else if(options === 'negative') {
        incrementalValue = incrementalValue < 0 ? incrementalValue * -1 : 0;
      }
      sum += incrementalValue;
    });
    return sum;
  };
}
